interface DeviceOptions {
  publicKey: string;
  endpoint: string;
  userConsent: boolean;
  context: string;
  includeCookies: boolean;
}

interface DevicerResponse {
  sessionId: string;
}

declare global {
  interface Window {
    devicer: {
      run: (
        deviceOptions: DeviceOptions,
        responseCb: (response: DevicerResponse) => void,
        errorCb: (error: unknown) => void
      ) => void;
    };
  }
}

export const runDevicer = (deviceOptions: DeviceOptions) =>
  new Promise<DevicerResponse>((resolve, reject) =>
    window.devicer.run(deviceOptions, resolve, reject)
  );
